import { useEffectOnce } from 'react-use';
import { Loader } from 'components/Loader';
import { withScreenerMachineState } from 'domains/signup/screener/context/screenerContext';
import { routes } from 'router/routes';
import { useNavigation } from 'utils/hooks/useNavigation';

const Finished: React.FC = () => {
  const { navigate } = useNavigation();

  useEffectOnce(() => {
    // @HACK:FIXME:(juan): find a way of doing this from the machine, this is a workaround
    navigate(routes.screener.results.base);
  });
  return (
    <>
      <Loader className="flex justify-center p-24 text-primary-500" />
    </>
  );
};

export const ScreenerFinished = withScreenerMachineState(Finished, 'finished');
